export const EquipmentBookingController = {
    index(): void {},
    create(): void {},
    store(): void {},
    show(): void {},
};
